import { NgModule } from '@angular/core';
import { CartFeatureModule } from '@app/cart';
import {
  AuthModule,
  CartModule,
  ExternalRoutesModule,
  ProductModule,
  UserTransitionalModule,
} from 'haba-core';
import {
  CartEmporixModule,
  CartEntryEmporixModule,
  CartVoucherEmporixModule,
  CheckoutServiceEmporixModule,
  OauthEmporixModule,
  ProductEmporixModule,
  ShoppingListEmporixModule,
  SiteEmporixModule,
  UserEmporixModule,
  HanaOndemandModule,
} from 'haba-emporix';
import {
  CartComponentModule,
  CartPageEventModule,
  HomePageEventModule,
  LoginRouteModule,
  LogoutModule,
  NavigationEventModule,
  ProductDetailsPageModule,
  ProductListingPageModule,
  ProductPageEventModule,
  ProductSummaryModule,
  ProductTabsModule,
  TabParagraphContainerModule,
} from 'haba-storefrontlib';
import { GlobalMessageCustomComponentFeatureModule } from 'src/app/misc/global-message/global-message-feature.module';
import { CheckoutFeatureModule } from 'src/app/spartacus/features/checkout/checkout-feature.module';
import { ProductVariantsFeatureModule } from 'src/app/spartacus/features/product/product-variants-feature.module';
import { UserFeatureModule } from 'src/app/user/user-feature.module';

@NgModule({
  declarations: [],
  imports: [
    // Auth Core
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    // Basic Cms Components
    TabParagraphContainerModule,
    // User Core,
    UserTransitionalModule,
    // Product Core,
    ProductModule.forRoot(),
    // Product UI,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductTabsModule,
    ProductSummaryModule,
    // Cart Core,
    CartModule.forRoot(),
    // Cart UI,
    CartComponentModule,
    // Order,

    // Page Events,
    NavigationEventModule,
    HomePageEventModule,
    CartPageEventModule,
    ProductPageEventModule,
    // External routes,
    ExternalRoutesModule.forRoot(),
    UserFeatureModule,
    ProductVariantsFeatureModule,
    CheckoutFeatureModule,
    CartFeatureModule,
    GlobalMessageCustomComponentFeatureModule,

    OauthEmporixModule,
    ProductEmporixModule,
    CartEmporixModule,
    CartEntryEmporixModule,
    SiteEmporixModule,
    UserEmporixModule,
    CheckoutServiceEmporixModule,
    CartVoucherEmporixModule,
    ShoppingListEmporixModule,
    HanaOndemandModule,
  ],
})
export class SpartacusFeaturesModule {}
